import styled from 'styled-components';
import Avatar from '@mui/material/Avatar';
import { Typography } from '@mui/material';
import { Grid } from '@mui/material';

export const StyledGridContainer = styled(Grid)(({ theme }) => `   
    background: rgba(145, 142, 250, 0.11);
    padding: 16px !important;
    border-radius: 4px;
    box-shadow: 0px 0px 0px 1px ${theme.uptimeColors.grayScales.boxShadow}; 
    min-width: 300px;
    height: 100%;
    .grid-manager-info {
      display: flex;
      flex-direction: row;
      & > div {
        width: 100% !important;
      }
    };

    @media screen and (max-width: ${theme.breakpoints.md}) {
      .grid-manager-info {
        flex-direction: column;
      }
    }

`);

export const StyledTypographyTitle = styled(Typography)(({ theme }) => `
    color: rgba(0, 0, 0, 0.70);
    min-width: 125px;
    display: flex;
    flex-direction: row-reverse;
    padding-right: 8px;
    font-size: 12px !important;
    font-weight: 600 !important;
    line-height: 160%;
`);

export const StyledTypographyContent = styled(Typography)(({ theme }) => `
    color: rgba(0, 0, 0, 0.70);
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 160% !important;
`);


export const StyledTypographyHeader = styled(Typography)(({ theme }) => `
    padding: 4px 0;
    font-size: 16px;
    font-weight: 600 !important;
    line-height: 18px;
    text-transform: capitalize;
`);

export const StyledAvatar = styled(Avatar)`
  width: 67px !important;
  height: 67px !important;
  font-size: 20px !important;
  svg {
    font-size: 4.5em;
  }
  &.avatar-new-joiner {
    width: 118px !important;
    height: 118px !important;
    font-size: 40px !important;
  }
`;

export const StyledRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 8px 0px 0px;
    &.header-report-manager {
      justify-content: center;
      width: 80%;
      padding: 0px;
    };       
`;

export const StyledCol = styled.div`
    display: flex;
    flex-direction: column;       
`;


export const StyledTypographyEmail = styled(Typography)(({ theme }) => `
    max-width: 224px;
    
`);
